import { fetchCategories } from "@/api/landing";
const images = [
  require("@/assets/cardScientificAndTechnical.png"),
  require("@/assets/cardTourism.png"),
  require("@/assets/cardEcological.png"),
  require("@/assets/card9.png"),
  require("@/assets/cardSocioPedagogical.png"),
  require("@/assets/cardHumanitarian.png"),
  require("@/assets/card7.png"),
  require("@/assets/card8.png"),
  require("@/assets/card9.png"),
  require("@/assets/card9.png"),
  require("@/assets/cardDances.png"),
  require("@/assets/cardSport.png"),
];

export default {
  namespaced: true,
  state: {
    categories: [],
    loading: false,
  },
  mutations: {
    SET_CATEGORIES(state, categories) {
      state.categories = categories.map((item, index) => ({
        ...item,
        image: images[index % images.length],
      }));
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async loadCategories({ commit, state }) {
      if (state.categories.length > 0) return;
      commit("SET_LOADING", true);
      try {
        const response = await fetchCategories();
        commit("SET_CATEGORIES", response.data);
      } catch (error) {
        console.error("Ошибка загрузки категорий:", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    getCategories: (state) => state.categories,
    isCategoriesLoading: (state) => state.loading,
  },
};
